import styles from './page-skeleton.module.css';

/**
 * CSS-only loading placeholder shaped like the list/table rows it stands in
 * for (same pattern as the sidebar skeleton). Rendered while catalog
 * providers fetch their entities; honors prefers-reduced-motion.
 */
export function PageSkeleton(props: { rows?: number }) {
  const rows = props.rows ?? 6;
  return (
    <div className={styles.skeleton} role="status" aria-label="Loading">
      {Array.from({ length: rows }, (_, index) => (
        <div key={index} className={styles.row} />
      ))}
    </div>
  );
}
